import React, { FunctionComponent } from 'react';
import {ClassBuilder} from 'b302-frontend-library';

interface Props {
    children: any;

    className?: string;
    onClick?: () => void;
}

const Card: FunctionComponent<Props> = ({ children, className, onClick }) => {

    const getClassName = () => {
        return ClassBuilder.createClass('card')
            .addIf(className, className)
            .build();
    };

    return (
        <div className={getClassName()} onClick={onClick}>
            { children }
        </div>
    );
};

export default Card;
